import { render, staticRenderFns } from "./sssTable.vue?vue&type=template&id=4621cf36&scoped=true"
import script from "./sssTable.vue?vue&type=script&lang=ts"
export * from "./sssTable.vue?vue&type=script&lang=ts"
import style0 from "./sssTable.vue?vue&type=style&index=0&id=4621cf36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4621cf36",
  null
  
)

export default component.exports